<template>
  <div class="main">
    <Header
      :show="true"
      title="访客"
      left=""
      right="exit"
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div>
      <div style="height: 50px; background-color: #0089ff; padding: 40px 20px">
        <van-row
          gutter="20"
          type="flex"
          justify="space-between"
          style="color: #ffffff"
        >
          <van-col span="17">
            <van-row style="font-size: 18px; margin: 0 0 10px">
              预约访问
            </van-row>
            <van-row style="font-size: 15px">
              在入厂前请先进行访问预约
            </van-row>
          </van-col>
          <van-col span="7">
            <el-button
              type="success"
              size="small"
              round
              @click="handleClickOrderDialog"
            >
              <span style="font-size: 15px">立即预约</span>
            </el-button>
          </van-col>
        </van-row>
      </div>
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <div
                style="
                  width: 4px;
                  height: 2.2vh;
                  background-color: #ea7e2d;
                  border-radius: 0.6vw;
                  float: left;
                  margin-top: 2px;
                "
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
              >操作指引</span>
            </div>
          </template>
          <template #right-icon>
            <img
              src="@/assets/svg/iconCaoZuoBangZhu.svg"
              height="26px;"
              @click="handleClickHelp"
            >
          </template>
        </van-cell>
      </van-cell-group>

      <!-- <div style="height: 8px; background-color: #F8F8F8;" /> -->
      <van-notice-bar
        left-icon="volume-o"
        color="#1989fa"
        background="#ecf9ff"
        :text="guide"
      />
      <van-grid
        style="font-size: 0.36rem; color: #999999"
        :border="false"
        :center="false"
        :column-num="1"
      >
        <van-grid-item>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #ffffff;
              padding: 0 0;
            "
          >
            <!-- <van-image src="https://img.yzcdn.cn/vant/cat.jpeg" /> -->
            <img
              src="@/assets/dashboard/images/office-follow.jpg"
              height="260rem;"
              @click="handleClickPreviewFollow"
            >
          </div>
        </van-grid-item>
      </van-grid>

      <div style="height: 8px; background-color: #f8f8f8" />
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <div
                style="
                  width: 4px;
                  height: 2.2vh;
                  background-color: #ea7e2d;
                  border-radius: 0.6vw;
                  float: left;
                  margin-top: 2px;
                "
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
              >历史记录</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <div style="background-color: #ffffff; padding: 0.6rem 0.6rem 0.6rem">
        <el-timeline style="padding: 0 0.1rem; text-align: left">
          <div
            v-if="timeOrderList.length <= 0"
            style="text-align: center; color: #909399"
          >
            无记录
          </div>
          <el-timeline-item
            v-for="activity in timeOrderList"
            v-else
            :key="activity.time"
            :timestamp="activity.time"
            placement="top"
          >
            <el-card>
              <van-cell
                center
                style="padding: 0 !important; border: 0; line-height: 0.3rem"
              >
                <template #title>
                  <h4
                    v-if="activity.status === '告警'"
                    style="color: #e6a23c"
                  >
                    {{ activity.title }}
                  </h4>
                  <h4
                    v-else-if="activity.status === '正常'"
                    style="color: #67c23a"
                  >
                    {{ activity.title }}
                  </h4>
                  <h4
                    v-else-if="activity.status === '故障'"
                    style="color: #f56c6c"
                  >
                    {{ activity.title }}
                  </h4>
                  <h4
                    v-else
                    style="color: #909399"
                  >
                    {{ activity.title }}
                  </h4>
                </template>
                <template #right-icon>
                  <span style="color: cornflowerblue; font-size: 0.36rem" />
                </template>
              </van-cell>
              <p>{{ activity.content }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div style="height: 3.8rem; background-color: #f8f8f8" />
      <van-popup
        v-model="showNavButton"
        round
        style="width: 80%"
      >
        <div style="text-align: center">
          <div style="padding: 24px">
            <div
              style="font-size: 18px; font-weight: bold; margin-bottom: 12px"
            >
              立即预约
            </div>
            <div style="font-size: 14px">
              请选择您的访问方式
            </div>
          </div>
          <div
            style="display: flex"
            class="yuyue-btn-wrap"
          >
            <div style="flex: 1">
              <van-button
                block
                color="#58bd6a"
                plain
                hairline
                @click="$router.push('/dashboard/order/man')"
              >
                人员
              </van-button>
            </div>
            <div style="flex: 1">
              <van-button
                block
                color="#4187f2"
                plain
                hairline
                @click="$router.push('/dashboard/order/car')"
              >
                车辆
              </van-button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <Footer
      :show="false"
      value="dashboard"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dialog, ImagePreview } from "vant";
import { parseTime } from "@/utils";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { showPhoneAlarm } from "@/global/function.js";
import { visitor, supplier } from "@/views/dashboard/config.json";
import {
  getManOrderList,
  getManAccessList,
  getTruckOrderList,
  getTruckAccessList,
  getMaterialCheckList,
  getProjectConfigList,
  getAggregateTruckStay,
} from "@/api/order.js";

export default {
  name: "DashboardOrder",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    const EDate = parseTime(new Date(), "{y}/{m}/{d}");
    const dayTimeStamp = new Date(EDate).getTime();
    const beforeTimeStamp = dayTimeStamp - 7 * 24 * 3600 * 1000;
    const SDate = parseTime(beforeTimeStamp, "{y}/{m}/{d}");
    return {
      listQuery: {
        limit: 10,
        page: 1,
        start: beforeTimeStamp,
        end: dayTimeStamp,
      },
      showNavButton: false,
      telphone: "0797-8181868",
      isLoading: false,
      guide: "欢迎您光临赣州永固高新材料有限公司！",
      maxStayNum: 0,
      orderList: [],
      accessList: [],
      weighList: [],
      checkList: [],
    };
  },
  computed: {
    ...mapGetters({
      personType: "user/personType",
    }),
    timeOrderList: function () {
      const data1 = this.orderList.concat(this.accessList);
      const data2 = this.weighList.concat(this.checkList);
      let data = data1.concat(data2);
      for (let i = 0; i < data.length; i++) {
        data[i].id = i + 1;
      }
      return this.sortByKey(data, "stamp");
    },
  },
  watch: {
    timeOrderList: {
      handler(newVal, oldVal) {
        if (newVal !== undefined && newVal.length > 0) {
          const index = newVal[0].index;
          this.guide = visitor[index];
        }
      },
      immediate: true,
    },
  },
  beforeCreate() {},
  created() {
    if (this.personType === 3) {
      this.handleGetProjectConfigList();

      this.handleGetTruckOrderList();
      this.handleGetTruckAccessList();
      this.handleGetMaterialCheckList();
    } else if (this.personType === 0) {
      this.handleGetManOrderList();
      this.handleGetManAccessList();
    }
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      // this.$router.go(-1)
      console.log("dashboard-left");
    },
    handleClickRight() {
      Dialog.confirm({
        title: "确认退出登录？",
        message: "再次访问需要重新登录",
      })
        .then(async () => {
          await this.$store.dispatch("user/logout");

          this.$router.push({
            path: "/login",
          });
        })
        .catch(() => {
          showPhoneAlarm(true, "toast", null, 2000, 200, "退出登录", "取消");
        });
    },
    handleClickHelp() {
      // window.location.href = 'tel: ' + this.telphone
      Dialog.alert({
        title: "获取帮助",
        message: "如果您遇到什么问题，请联系：\n0797-8181868",
      }).then(() => {});
    },
    handleClickPreviewFollow() {
      ImagePreview({
        images: [
          require("@/assets/dashboard/images/office-follow.jpg"),
          require("@/assets/dashboard/images/aggregate-follow.jpg"),
          require("@/assets/dashboard/images/tank-follow.jpg"),
        ],
        closeable: true,
      });
    },
    handleClickOrderDialog() {
      this.showNavButton = true;
    },
    sortByKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x > y ? 1 : 0;
      });
    },
    handleGetManOrderList() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getManOrderList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.orderList = [];
            for (let i = 0; i < items.length; i++) {
              let gateName = "办公区";
              if (items[i].gate === 1) {
                gateName = "办公区";
              } else if (items[i].gate === 2) {
                gateName = "生产区";
              } else if (items[i].gate === 3) {
                gateName = "办公区及生产区";
              }
              if (items[i].createdTime > this.listQuery.start) {
                this.orderList.push({
                  index: "order-apply",
                  stamp: items[i].createdTime,
                  time: parseTime(
                    items[i].createdTime,
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  ),
                  title: "访问预约 - 待审核",
                  content:
                    "起止日期：" +
                    parseTime(items[i].startDate, "{y}/{m}/{d}") +
                    " - " +
                    parseTime(items[i].endDate, "{y}/{m}/{d}") +
                    "，访问人员：" +
                    items[i].name +
                    "，访问区域：" +
                    gateName,
                  status: "告警",
                  type: "",
                });
                if (items[i].audit === 1 || items[i].audit === 2) {
                  this.orderList.push({
                    index:
                      items[i].audit === 1 ? "order-agree" : "order-refuse",
                    stamp: items[i].updatedTime,
                    time: parseTime(
                      items[i].updatedTime,
                      "{y}-{m}-{d} {h}:{i}:{s}"
                    ),
                    title:
                      "访问预约 - " +
                      (items[i].audit === 1 ? "已通过" : "已拒绝"),
                    content:
                      "起止日期：" +
                      parseTime(items[i].startDate, "{y}/{m}/{d}") +
                      " - " +
                      parseTime(items[i].endDate, "{y}/{m}/{d}") +
                      "，访问人员：" +
                      items[i].name +
                      "，访问区域：" +
                      gateName +
                      `${
                        items[i].audit !== 1
                          ? "，拒绝原因：" + items[i].rejectReason
                          : ""
                      }`,
                    status: items[i].audit === 1 ? "正常" : "故障",
                    type: "",
                  });
                }
              }
            }
            console.log("getManOrderList");
            console.log(this.orderList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetManAccessList() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getManAccessList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.accessList = [];
            for (let i = 0; i < items.length; i++) {
              if (items[i].accessTime > this.listQuery.start) {
                this.accessList.push({
                  index: "gate-access",
                  stamp: items[i].accessTime,
                  time: parseTime(
                    items[i].accessTime,
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  ),
                  title: "访问入场",
                  content:
                    "访问区域：" +
                    items[i].gateName +
                    "，访问人员：" +
                    items[i].personName,
                  status: "结束",
                  type: "",
                });
                if (items[i].exitTime !== "" && items[i].exitTime !== null) {
                  this.accessList.push({
                    index: "gate-exit",
                    stamp: items[i].exitTime,
                    time: parseTime(
                      items[i].exitTime,
                      "{y}-{m}-{d} {h}:{i}:{s}"
                    ),
                    title: "访问出场",
                    content:
                      "访问区域：" +
                      items[i].gateName +
                      "，访问人员：" +
                      items[i].personName,
                    status: "结束",
                    type: "",
                  });
                }
              }
            }
            console.log("getAccessList");
            console.log(this.accessList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetProjectConfigList() {
      const data = {};
      getProjectConfigList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            this.maxStayNum =
              +items.find((item) => item.name === "骨料车最大在场数量")
                ?.value || 0;

            this.handleGetAggregateTruckStay();
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetAggregateTruckStay() {
      const data = {};
      getAggregateTruckStay(data)
        .then((response) => {
          const { data } = response;

          if (this.maxStayNum <= data.data) {
            this.guide = "无空闲骨料车位，请稍候入厂！";
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetTruckOrderList() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getTruckOrderList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.orderList = [];
            for (let i = 0; i < items.length; i++) {
              if (items[i].createdTime > this.listQuery.start) {
                this.orderList.push({
                  index: "order-apply",
                  stamp: items[i].createdTime,
                  time: parseTime(
                    items[i].createdTime,
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  ),
                  title: "访问预约 - 待审核",
                  content:
                    "起止日期：" +
                    parseTime(items[i].startDate, "{y}/{m}/{d}") +
                    " - " +
                    parseTime(items[i].endDate, "{y}/{m}/{d}") +
                    "，车牌号码：" +
                    items[i].plateNumber +
                    "(" +
                    items[i].name +
                    ")" +
                    "，供应商：" +
                    items[i].supplierName +
                    "，供应物料：" +
                    items[i].materialName,
                  status: "告警",
                  type: "",
                });
                if (items[i].audit === 1 || items[i].audit === 2) {
                  this.orderList.push({
                    index:
                      items[i].audit === 1 ? "order-agree" : "order-refuse",
                    stamp: items[i].updatedTime,
                    time: parseTime(
                      items[i].updatedTime,
                      "{y}-{m}-{d} {h}:{i}:{s}"
                    ),
                    title:
                      "访问预约 - " +
                      (items[i].audit === 1 ? "已通过" : "已拒绝"),
                    content:
                      "起止日期：" +
                      parseTime(items[i].startDate, "{y}/{m}/{d}") +
                      " - " +
                      parseTime(items[i].endDate, "{y}/{m}/{d}") +
                      "，车牌号码：" +
                      items[i].plateNumber +
                      "(" +
                      items[i].name +
                      ")" +
                      "，供应商：" +
                      items[i].supplierName +
                      "，供应物料：" +
                      items[i].materialName +
                      `${
                        items[i].audit !== 1
                          ? "，拒绝原因：" + items[i].rejectReason
                          : ""
                      }`,
                    status: items[i].audit === 1 ? "正常" : "故障",
                    type: "",
                  });
                }
              }
            }
            console.log("getOrderList");
            console.log(this.orderList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetTruckAccessList() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getTruckAccessList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.accessList = [];
            for (let i = 0; i < items.length; i++) {
              if (items[i].accessTime > this.listQuery.start) {
                this.accessList.push({
                  index: "barrier-access",
                  stamp: items[i].accessTime,
                  time: parseTime(
                    items[i].accessTime,
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  ),
                  title: "访问入场",
                  content:
                    "车牌号码：" +
                    items[i].plateNumber +
                    "(" +
                    items[i].driver +
                    ")",
                  status: "结束",
                  type: "",
                });
                if (items[i].exitTime !== "" && items[i].exitTime !== null) {
                  this.accessList.push({
                    index: "barrier-exit",
                    stamp: items[i].exitTime,
                    time: parseTime(
                      items[i].exitTime,
                      "{y}-{m}-{d} {h}:{i}:{s}"
                    ),
                    title: "访问出场",
                    content:
                      "车牌号码：" +
                      items[i].plateNumber +
                      "(" +
                      items[i].driver +
                      ")",
                    status: "结束",
                    type: "",
                  });
                }
              }
            }
            console.log("getAccessList");
            console.log(this.accessList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetMaterialCheckList() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getMaterialCheckList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.checkList = [];
            for (let i = 0; i < items.length; i++) {
              if (items[i].createdTime > this.startDateStamp) {
                this.checkList.push({
                  index:
                    items[i].materialType === "骨料"
                      ? "gross-aggregate"
                      : "gross-tank",
                  stamp: items[i].createdTime,
                  time: parseTime(
                    items[i].createdTime,
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  ),
                  title: "开罐申请 - 待审核",
                  content:
                    "车牌号码：" +
                    items[i].plateNumber +
                    "，供应商：" +
                    items[i].supplierName +
                    "，供应物料：" +
                    items[i].materialName +
                    "，申请罐口：" +
                    items[i].port,
                  status: "结束",
                  type: "",
                });
                if (
                  items[i].updatedTime !== "" &&
                  items[i].updatedTime !== null
                ) {
                  this.checkList.push({
                    index:
                      items[i].materialType === "骨料"
                        ? "tare-aggregate"
                        : "tare-tank",
                    stamp: items[i].updatedTime,
                    time: parseTime(
                      items[i].updatedTime,
                      "{y}-{m}-{d} {h}:{i}:{s}"
                    ),
                    title:
                      "开罐申请 - " +
                      (items[i].status === 1 ? "已通过" : "已拒绝"),
                    content:
                      "车牌号码：" +
                      items[i].plateNumber +
                      "，供应商：" +
                      items[i].supplierName +
                      "，供应物料：" +
                      items[i].materialName +
                      "，申请罐口：" +
                      items[i].port +
                      `${
                        items[i].audit !== 1
                          ? "，拒绝原因：" + items[i].rejectReason
                          : ""
                      }`,
                    status: "结束",
                    type: "",
                  });
                }
              }
            }
            console.log("getMaterialCheckList");
            console.log(this.checkList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
.van-cell {
  padding: 1.5vw 3vw;
}
::v-deep .van-grid-item__content {
  padding: 0 0;
}
::v-deep .van-dialog__message {
  padding: 20px 24px 12px;
  font-size: 0.36rem;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
.day-statistics {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
}

.yuyue-btn-wrap {
  ::v-deep .van-button {
    border-color: #ebedf0 !important;
  }
}
</style>
